import { ProfileCard } from "@/components/about/ProfileCard";
import { site } from "@/lib/site";
import { useDocumentTitle } from "@/lib/use-document-title";

export function AboutPage() {
    useDocumentTitle(site.titles.about);

    return (
        <section className="px-(--kt-gutter) pt-19 pb-23">
            {/* Heading level is semantics, heading size is design: this is the page's
                h1 even though it is styled as the 12px kicker. */}
            <h1 className="mb-8.5 text-[12px] uppercase tracking-kicker text-kt-accent">About</h1>
            <ProfileCard />
        </section>
    );
}
